import { render } from "./App.vue?vue&type=template&id=6b2fedce&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6b2fedce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b2fedce"

export default script